import React from "react";
import { Modal, NewTable } from "../../../../../../components";
import { mapTableRows } from "../../../../../../utils";

const FinalizeModal = ({ isOpen, onClose }) => {
  const rowsdata = [];

  const Columns = [
    { key: "Description", label: "Employee Name" },
    { key: "DueDate", label: "Employee ID" },
    { key: "OriginalAmount", label: "Employee Category " },
    { key: "PaymentReceived", label: "Release Date" },
    { key: "OpenBalance", label: "Invoice Amount" },
    { key: "EnterPaymentAmount", label: "Bonus Eligible" },
    { key: "PaymentDiscount", label: " Credit Available" },
  ];
  const mappedRows = mapTableRows(rowsdata, Columns);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="ADD EMPLOYEE TO PAYCYCLE"
      width="max-w-7xl"
    >
      <NewTable
        showCheckbox
        columns={Columns}
        rows={mappedRows}
        toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
      />
    </Modal>
  );
};

export default FinalizeModal;
